import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, Observable, timer, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CUtilit } from 'src/app/classes/utilit';
import { Router } from '@angular/router';
import { HomeScreenElement, VisibilityElementToolbar } from 'src/app/classes/json-interface';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { MatMenu } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { MenuButtonService } from 'src/app/services/menu-button/menu-button.service';
import { DialogParamComponent } from '../../dialog/dialogParametre/param.component';
import { CST_LOCALSTORAGE_VALUE } from 'src/app/classes/const';
import { AppToolbarService } from '../services/app-toolbar.service';
import { LoggedUserService } from 'src/app/services/loged-user/loged-user.service';
import { g_params } from 'src/app/classes/global-param';

export const CST_TOOLBAR_BTN_EVENT = {
  Home: 'HOME',
  Logout: 'LOGOUT',
  Refresh: 'REFRESH',
  NewWebOrder: 'NEWWEBORDER',
  Close: 'CLOSE',
  SaveOrder: 'SAVEORDER',
  SendOrder: 'SENDORDER',
  HideShape: 'HIDESHAPE',
  Return: 'RETURN'
};

// Ne devrais pas exister juste garde CST_EMPTY_DISPOTITION & le reste devrais etre reconstruit en fonction de chaque page
//                                            {       trad auto          |   }
export const CST_REFRESH_BTN: ToolbarButton = { name: 'Rafraichir', color: '',        eventName: CST_TOOLBAR_BTN_EVENT.Refresh};
export const CST_RETURN_BTN: ToolbarButton  = { name: 'Return',     color: 'accent',  eventName: CST_TOOLBAR_BTN_EVENT.Return};

export const CST_EMPTY_DISPOTITION: ToolbarDisposition = { start: [], end: [] };
export const CST_HOME_DISPOTITION: ToolbarDisposition = CST_EMPTY_DISPOTITION;
export const CST_WEB_INPUT_DISPOSITION: ToolbarDisposition = { start: [CST_REFRESH_BTN], end: [] };
export const CST_LIST_REFRESH_DISPOTITION: ToolbarDisposition = { start: [CST_REFRESH_BTN], end: [] };
export const CST_RETURN_DISPOTITION: ToolbarDisposition = { start: [], end : [CST_RETURN_BTN] };

@Component({
  selector: 'app-app-tool-bar',
  templateUrl: './app-tool-bar.component.html',
  styleUrls: ['./app-tool-bar.component.css']
})
export class AppToolBarComponent implements OnInit {

  private mSubject: Subject<string>;
  private mSubjectChangementChantier: Subject<string>;

  private mLockBtnToolbar: boolean;       // Utiliser le getter pour connaitre l'état du lock
  private mSubscriberLock?: Subscription;  // Pour debloquer la toolbar apres x temps

  CST_ARRAY_TOOLBAR_START_BTN: ToolbarButton[] = [];
  CST_ARRAY_TOOLBAR_END_BTN: ToolbarButton[] = [];

  HTML_VisibilityLogout: boolean;
  HTML_VisibilityToolbar: boolean;

  HTML_PageTitle: string;

  HTML_ArrayHomeScreenItem: HomeScreenElement[] = [];

  mVisibilityElementToolbar?: VisibilityElementToolbar;

  @ViewChild('menu', {static: false}) menu!: MatMenu;
  @ViewChild('ariaToolbar', {static: false}) mAriaToolbar!: HTMLElement;

  constructor(private http: HttpClient,
              private router: Router,
              private mDialog: MatDialog,
              private mMenuItem: MenuButtonService,
              private mToolbatService: AppToolbarService,
              private mLoggedUser: LoggedUserService) {
    this.HTML_VisibilityLogout = false;
    this.HTML_VisibilityToolbar = true;
    this.mSubject = new Subject();
    this.mSubjectChangementChantier = new Subject();
    this.HTML_PageTitle = '';
    this.mLockBtnToolbar = false;
    this.initVisibilityElementToolbar();
  }

  ngOnInit() {
    this.mToolbatService.setToolbarComponent(this);
  }

  menuOpened() {
    this.HTML_ArrayHomeScreenItem = this.mMenuItem.getArrayMenuItem();
  }

  onLogOutClick() {
    this.menu.close.emit();
    ArmaServConnection.LogoutArmawebAngular(this.router, this.http);
  }

  refresh(cleanSiteCode: boolean) {

  }

  /**
   * Appeler depuis le HTML, gere le changement de chantier
   * @param value Nouveau code chantier
   */
  onSiteChange(value: string) {
    this.mSubjectChangementChantier.next(value);  // Alerte du changement de chantier
  }

  onBtnClick(itemBtn: ToolbarButton) {
    if (itemBtn) {
      if (itemBtn.eventName == CST_TOOLBAR_BTN_EVENT.Logout) {
        ArmaServConnection.LogoutArmawebAngular(this.router, this.http);
      } else if (itemBtn.eventName == CST_TOOLBAR_BTN_EVENT.Home) {
        this.router.navigateByUrl('home');
      } else {
        this.mSubject.next(itemBtn.eventName);
      }
    }
  }

  async onArmaorLogoClick() {
    let routeToNavigate = '';
    switch (this.router.url) {
      case '/shapes':
        routeToNavigate = 'login';
        break;
      default:
        routeToNavigate = 'home';
        break;
    }
    this.router.navigateByUrl(routeToNavigate);
  }

  onParamClick() {
    DialogParamComponent.openParam(this.mDialog);
  }

  getUserName(): string {
    return CUtilit.getUserName();
  }

  /**
   * @param visibilityElement On peut préciser qu'un seul element a modifier, la fonction ne modifira pas les autres visibiliité
   */
  public setVisibilityElementToolbar(visibilityElement: VisibilityElementToolbar) {
    for (const key in visibilityElement) {
      if (visibilityElement.hasOwnProperty(key)) {
        // @ts-ignore TODO: TS7053: Element implicitly has an 'any'
        this.mVisibilityElementToolbar[key] = visibilityElement[key];
      }
    }
  }

  public initVisibilityElementToolbar() {
    this.mVisibilityElementToolbar = {
      ArmaorLogo: true,
      ArrayStartBtn: true,
      Title: true,
      SiteSelect: true,
      ArrayEndBtn: true,
      MenuBtn: true
    };
    if (this.menu && this.menu.close)
      this.menu.close.emit(); // Ferme le menu
  }

  public updateDispotition(disposition: ToolbarDisposition) {
    if (!disposition) disposition = CST_EMPTY_DISPOTITION;
    this.CST_ARRAY_TOOLBAR_START_BTN = disposition.start;
    this.CST_ARRAY_TOOLBAR_END_BTN = disposition.end;
  }

  public getObservableBtnClick(clear: boolean): Observable<string> {
    if (clear) this.mSubject.observers.length = 0;
    return this.mSubject.asObservable();
  }

  public getObservableSiteChange(): Observable<string> {
    this.mSubjectChangementChantier.observers.length = 0;
    return this.mSubjectChangementChantier.asObservable();
  }

  public setLockToolbatButton(lock: boolean, timeout: number = 20000) {
    this.mLockBtnToolbar = lock;
    if (lock) {
      this.mSubscriberLock = timer(timeout).subscribe(next => {
        // On unlock apres X ms
        this.mLockBtnToolbar = false;
      });
    } else {
      if (this.mSubscriberLock) this.mSubscriberLock.unsubscribe();
    }
  }

  public get getNgClassBgColorStyleColor(): any {
    return CUtilit.getNgStyleBackgroundColor(
      this.mLoggedUser.isArmaorUserConnected,
      this.mLoggedUser.isCustomerConnected
    );
  }

  public get armaorStyleColor(): any {
    if (this.mLoggedUser.isArmaorUserConnected)
      return CUtilit.getArmaorUserColorCode();
    return CUtilit.getUserSiteColorCode();
  }

  public get arraySite() {
    return g_params.g_arraySite;
  }

  public get HTML_LOCK_BTN(): boolean {
    return this.mLockBtnToolbar;
  }

  public get visibilityElement(): VisibilityElementToolbar | undefined {
    return this.mVisibilityElementToolbar;
  }

  get selectedSiteCode() {
    return sessionStorage.getItem(CST_LOCALSTORAGE_VALUE.SelectedSiteCode);
  }

}

export interface ToolbarDisposition {
  start: ToolbarButton[];
  end: ToolbarButton[];
}

export interface ToolbarButton {
  name: string;
  color: string;
  readonly eventName: string;
  btnDisabled?: boolean;      // Doit etre reset a false à chaque modification de disposition
}
